<div class="card mb-5">
  <header
    *ngIf="!dataStoreSetting.defaultPricing"
    class="w-100 align-items-center gap-2 rounded"
    style="
      background-color: transparent;
      box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
      border-left: 5px solid #3199d0;
    "
  >
    <div class="row justify-content-between">
      <div class="col">
        <h4 class="fs-6 mt-3 fw-medium ms-3">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.3113 6.87846L17.1216 2.68971C16.9823 2.55038 16.8169 2.43986 16.6349 2.36446C16.4529 2.28905 16.2578 2.25024 16.0608 2.25024C15.8638 2.25024 15.6687 2.28905 15.4867 2.36446C15.3047 2.43986 15.1393 2.55038 15 2.68971L3.43969 14.25C3.2998 14.3888 3.18889 14.554 3.11341 14.736C3.03792 14.9181 2.99938 15.1133 3.00001 15.3103V19.5C3.00001 19.8978 3.15804 20.2794 3.43935 20.5607C3.72065 20.842 4.10218 21 4.50001 21H20.25C20.4489 21 20.6397 20.921 20.7803 20.7803C20.921 20.6397 21 20.4489 21 20.25C21 20.0511 20.921 19.8603 20.7803 19.7197C20.6397 19.579 20.4489 19.5 20.25 19.5H10.8113L21.3113 9.00002C21.4506 8.86073 21.5611 8.69535 21.6365 8.51334C21.7119 8.33133 21.7507 8.13625 21.7507 7.93924C21.7507 7.74222 21.7119 7.54714 21.6365 7.36513C21.5611 7.18312 21.4506 7.01775 21.3113 6.87846ZM8.68969 19.5H4.50001V15.3103L12.75 7.06033L16.9397 11.25L8.68969 19.5ZM18 10.1897L13.8113 6.00002L16.0613 3.75002L20.25 7.93971L18 10.1897Z"
              fill="#3199D0"
            />
          </svg>
          Edição
        </h4>
      </div>
    </div>
  </header>

  <div *ngIf="!dataStoreSetting.defaultPricing">
    <div class="card-body">
      <div class="mt-1 ps-2">
        <div class="row">
          <div class="col-12">
            <div class="d-flex gap-2 align-content-center align-items-center">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.5 7.5H8.5V3.5H9C9.53043 3.5 10.0391 3.71071 10.4142 4.08579C10.7893 4.46086 11 4.96957 11 5.5C11 5.63261 11.0527 5.75979 11.1464 5.85355C11.2402 5.94732 11.3674 6 11.5 6C11.6326 6 11.7598 5.94732 11.8536 5.85355C11.9473 5.75979 12 5.63261 12 5.5C11.9992 4.7046 11.6828 3.94202 11.1204 3.37959C10.558 2.81716 9.7954 2.50083 9 2.5H8.5V1.5C8.5 1.36739 8.44732 1.24021 8.35355 1.14645C8.25979 1.05268 8.13261 1 8 1C7.86739 1 7.74021 1.05268 7.64645 1.14645C7.55268 1.24021 7.5 1.36739 7.5 1.5V2.5H7C6.20435 2.5 5.44129 2.81607 4.87868 3.37868C4.31607 3.94129 4 4.70435 4 5.5C4 6.29565 4.31607 7.05871 4.87868 7.62132C5.44129 8.18393 6.20435 8.5 7 8.5H7.5V12.5H6.5C5.96957 12.5 5.46086 12.2893 5.08579 11.9142C4.71071 11.5391 4.5 11.0304 4.5 10.5C4.5 10.3674 4.44732 10.2402 4.35355 10.1464C4.25979 10.0527 4.13261 10 4 10C3.86739 10 3.74021 10.0527 3.64645 10.1464C3.55268 10.2402 3.5 10.3674 3.5 10.5C3.50083 11.2954 3.81716 12.058 4.37959 12.6204C4.94202 13.1828 5.7046 13.4992 6.5 13.5H7.5V14.5C7.5 14.6326 7.55268 14.7598 7.64645 14.8536C7.74021 14.9473 7.86739 15 8 15C8.13261 15 8.25979 14.9473 8.35355 14.8536C8.44732 14.7598 8.5 14.6326 8.5 14.5V13.5H9.5C10.2956 13.5 11.0587 13.1839 11.6213 12.6213C12.1839 12.0587 12.5 11.2956 12.5 10.5C12.5 9.70435 12.1839 8.94129 11.6213 8.37868C11.0587 7.81607 10.2956 7.5 9.5 7.5ZM7 7.5C6.46957 7.5 5.96086 7.28929 5.58579 6.91421C5.21071 6.53914 5 6.03043 5 5.5C5 4.96957 5.21071 4.46086 5.58579 4.08579C5.96086 3.71071 6.46957 3.5 7 3.5H7.5V7.5H7ZM9.5 12.5H8.5V8.5H9.5C10.0304 8.5 10.5391 8.71071 10.9142 9.08579C11.2893 9.46086 11.5 9.96957 11.5 10.5C11.5 11.0304 11.2893 11.5391 10.9142 11.9142C10.5391 12.2893 10.0304 12.5 9.5 12.5Z"
                  fill="#3199D0"
                />
              </svg>

              <p class="fw-medium m-0 p-0">Precificação</p>
            </div>

            <div class="row align-items-center">
              <div class="col-4">
                <div class="mt-2">
                  <div class="d-flex align-items-center gap-2">
                    <h3 class="p-0 m-0">Projeto de Consultoria</h3>
                  </div>
                  <p style="font-size: 12px" class="p-0 m-0 fw-light">
                    Mínimo R$ 3.000,00
                  </p>
                </div>
              </div>

              <div class="col-8">
                <div class="row">
                  <div class="col-12">
                    <span class="fw-medium">Valor Fixo</span>
                    <p class="text-dark-emphasis fw-light d-none">
                      Preencha o valor do item manualmente
                    </p>
                    <div class="col input-group">
                      <input
                        class="form-control"
                        type="text"
                        placeholder="R$ 3.000,00"
                        (blur)="manualValueAlert()"
                        [(ngModel)]="manualValueString"
                        style="border: 1px solid rgb(110, 110, 110)"
                      />
                    </div>
                  </div>
                </div>

                <div class="row align-items-center mt-4 mb-4">
                  <span
                    ><svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.0306 15.9694C11.1003 16.039 11.1556 16.1217 11.1933 16.2128C11.2311 16.3038 11.2505 16.4014 11.2505 16.5C11.2505 16.5985 11.2311 16.6961 11.1933 16.7872C11.1556 16.8782 11.1003 16.9609 11.0306 17.0306L8.03055 20.0306C7.9609 20.1003 7.87818 20.1557 7.78713 20.1934C7.69609 20.2311 7.59849 20.2506 7.49993 20.2506C7.40137 20.2506 7.30377 20.2311 7.21272 20.1934C7.12168 20.1557 7.03896 20.1003 6.9693 20.0306L3.9693 17.0306C3.89962 16.9609 3.84435 16.8782 3.80663 16.7872C3.76892 16.6961 3.74951 16.5985 3.74951 16.5C3.74951 16.4014 3.76892 16.3039 3.80663 16.2128C3.84435 16.1218 3.89962 16.039 3.9693 15.9694C4.11003 15.8286 4.30091 15.7496 4.49993 15.7496C4.59847 15.7496 4.69606 15.769 4.7871 15.8067C4.87815 15.8444 4.96087 15.8997 5.03055 15.9694L6.74993 17.6897V4.49998C6.74993 4.30107 6.82895 4.1103 6.9696 3.96965C7.11025 3.829 7.30102 3.74998 7.49993 3.74998C7.69884 3.74998 7.88961 3.829 8.03026 3.96965C8.17091 4.1103 8.24993 4.30107 8.24993 4.49998V17.6897L9.9693 15.9694C10.039 15.8996 10.1217 15.8443 10.2127 15.8066C10.3038 15.7688 10.4014 15.7494 10.4999 15.7494C10.5985 15.7494 10.6961 15.7688 10.7871 15.8066C10.8782 15.8443 10.9609 15.8996 11.0306 15.9694ZM20.0306 6.96935L17.0306 3.96935C16.9609 3.89962 16.8782 3.8443 16.7871 3.80656C16.6961 3.76882 16.5985 3.74939 16.4999 3.74939C16.4014 3.74939 16.3038 3.76882 16.2127 3.80656C16.1217 3.8443 16.039 3.89962 15.9693 3.96935L12.9693 6.96935C12.8286 7.11009 12.7495 7.30096 12.7495 7.49998C12.7495 7.699 12.8286 7.88987 12.9693 8.03061C13.11 8.17134 13.3009 8.2504 13.4999 8.2504C13.699 8.2504 13.8898 8.17134 14.0306 8.03061L15.7499 6.31029V19.5C15.7499 19.6989 15.8289 19.8897 15.9696 20.0303C16.1103 20.171 16.301 20.25 16.4999 20.25C16.6988 20.25 16.8896 20.171 17.0303 20.0303C17.1709 19.8897 17.2499 19.6989 17.2499 19.5V6.31029L18.9693 8.03061C19.11 8.17134 19.3009 8.2504 19.4999 8.2504C19.699 8.2504 19.8898 8.17134 20.0306 8.03061C20.1713 7.88987 20.2503 7.699 20.2503 7.49998C20.2503 7.30096 20.1713 7.11009 20.0306 6.96935Z"
                        fill="#C3C6CF"
                      />
                    </svg>
                    Maior valor entre os dois
                    <button
                      class="btn m-0 p-0 rounded-4"
                      (click)="openDialogConsultantProject()"
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.75 11.25C8.75 11.3983 8.70602 11.5433 8.6236 11.6667C8.54119 11.79 8.42406 11.8861 8.28701 11.9429C8.14997 11.9997 7.99917 12.0145 7.85368 11.9856C7.7082 11.9566 7.57456 11.8852 7.46967 11.7803C7.36478 11.6754 7.29335 11.5418 7.26441 11.3963C7.23548 11.2508 7.25033 11.1 7.30709 10.963C7.36386 10.8259 7.45999 10.7088 7.58333 10.6264C7.70666 10.544 7.85167 10.5 8 10.5C8.19892 10.5 8.38968 10.579 8.53033 10.7197C8.67098 10.8603 8.75 11.0511 8.75 11.25ZM8 4.5C6.62125 4.5 5.5 5.50938 5.5 6.75V7C5.5 7.13261 5.55268 7.25979 5.64645 7.35355C5.74022 7.44732 5.86739 7.5 6 7.5C6.13261 7.5 6.25979 7.44732 6.35356 7.35355C6.44732 7.25979 6.5 7.13261 6.5 7V6.75C6.5 6.0625 7.17313 5.5 8 5.5C8.82688 5.5 9.5 6.0625 9.5 6.75C9.5 7.4375 8.82688 8 8 8C7.86739 8 7.74022 8.05268 7.64645 8.14645C7.55268 8.24021 7.5 8.36739 7.5 8.5V9C7.5 9.13261 7.55268 9.25979 7.64645 9.35355C7.74022 9.44732 7.86739 9.5 8 9.5C8.13261 9.5 8.25979 9.44732 8.35356 9.35355C8.44732 9.25979 8.5 9.13261 8.5 9V8.955C9.64 8.74563 10.5 7.83625 10.5 6.75C10.5 5.50938 9.37875 4.5 8 4.5ZM14.5 8C14.5 9.28558 14.1188 10.5423 13.4046 11.6112C12.6903 12.6801 11.6752 13.5132 10.4874 14.0052C9.29973 14.4972 7.99279 14.6259 6.73192 14.3751C5.47104 14.1243 4.31285 13.5052 3.40381 12.5962C2.49477 11.6872 1.8757 10.529 1.6249 9.26809C1.37409 8.00721 1.50282 6.70028 1.99479 5.51256C2.48676 4.32484 3.31988 3.30968 4.3888 2.59545C5.45772 1.88122 6.71442 1.5 8 1.5C9.72335 1.50182 11.3756 2.18722 12.5942 3.40582C13.8128 4.62441 14.4982 6.27665 14.5 8ZM13.5 8C13.5 6.9122 13.1774 5.84883 12.5731 4.94436C11.9687 4.03989 11.1098 3.33494 10.1048 2.91866C9.09977 2.50238 7.9939 2.39346 6.92701 2.60568C5.86011 2.8179 4.8801 3.34172 4.11092 4.11091C3.34173 4.8801 2.8179 5.86011 2.60568 6.927C2.39347 7.9939 2.50238 9.09977 2.91867 10.1048C3.33495 11.1098 4.0399 11.9687 4.94437 12.5731C5.84884 13.1774 6.91221 13.5 8 13.5C9.45819 13.4983 10.8562 12.9184 11.8873 11.8873C12.9184 10.8562 13.4983 9.45818 13.5 8Z"
                          fill="#0B0C0E"
                        />
                      </svg></button
                  ></span>
                </div>

                <div class="row">
                  <div class="col-12">
                    <div>
                      <span class="fw-medium"
                        >Percentual da Renda Bruta Anual (RBA)</span
                      >
                      <p class="text-dark-emphasis fw-light d-none">
                        Preencha a porcentagem da RBA do cliente em que será
                        calculado o preço do item.
                      </p>
                      <div class="col input-group w-100">
                        <input
                          class="form-control"
                          type="text"
                          placeholder="3%"
                          maxlength="3"
                          [(ngModel)]="percentValueString"
                          style="border: 1px solid rgb(110, 110, 110)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <hr />
        </div>

        <div class="row">
          <div class="col-4">
            <h3 class="p-0 m-0">Serviço de Acompanhamento</h3>
            <p style="font-size: 12px" class="p-0 m-0 fw-light">
              Mínimo R$ 1.200,00
            </p>
          </div>
          <div class="col-8">
            <div class="input-group">
              <input
                class="form-control"
                type="text"
                placeholder="R$ 1.200,00"
                (blur)="followUpValueAlert()"
                [(ngModel)]="followUpServiceValueString"
                style="border: 1px solid rgb(110, 110, 110)"
              />
            </div>
          </div>
        </div>
        <div>
          <hr />
        </div>

        <div class="row">
          <app-credit-card-payment></app-credit-card-payment>
        </div>
        <div>
          <hr />
        </div>

        <div class="row">
          <app-in-cash-payment></app-in-cash-payment>
        </div>
      </div>
    </div>
  </div>
</div>
